import React from 'react';
import { SelectInput, Create, required, FormDataConsumer } from 'react-admin';
import { FormSpy, useForm } from 'react-final-form';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import isEqual from 'lodash/isEqual';

import SimpleFormWithSave from '../../../core/components/form/SimpleFormWithSave';
import UserNotificationLookups from './UserNotificationLookups';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
  fullWidth: {
    width: '100%'
  }
});

const selectRequired = [required()];

const UserNotificationFormFields = ({
  fundsChoices,
  documentTypes,
  allInvestors,
  fundInvestors,
  userAddressesTypesAvailable,
  loading
}) => {
  const classes = useStyles();
  const form = useForm();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <SelectInput
          variant="standard"
          choices={fundsChoices}
          source={'fundId'}
          className={classes.inputRoot}
          label="Fund"
          allowEmpty
          emptyText="All Funds"
          emptyValue="*"
          initialValue="*"
          validate={selectRequired}
          loading={loading}
          id="fund"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <FormDataConsumer>
          {({ formData }) => {
            let choices = allInvestors;
            if (formData.fundId !== '*') {
              choices = fundInvestors[formData.fundId] || [];
            }

            const currentValue = formData.investorId;
            if (!choices.find(item => item.id === currentValue)) {
              form.change('investorId', '*');
            }

            return (
              formData && (
                <SelectInput
                  variant="standard"
                  choices={choices}
                  source="investorId"
                  className={classes.inputRoot}
                  label="Investor"
                  allowEmpty
                  emptyText="All Investors"
                  disabled={!formData.fundId}
                  emptyValue="*"
                  initialValue="*"
                  validate={selectRequired}
                  loading={loading}
                  id="investor"
                />
              )
            );
          }}
        </FormDataConsumer>
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <SelectInput
          variant="standard"
          choices={documentTypes}
          source="documentTypeId"
          className={classes.inputRoot}
          label="Document Type"
          optionText="description"
          validate={selectRequired}
          allowEmpty={false}
          id="document"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <SelectInput
          label="Delivery Method"
          variant="standard"
          className={classes.inputRoot}
          source="deliveryMethod"
          choices={UserNotificationLookups.deliveryMethod}
          initialValue={UserNotificationLookups.deliveryMethod[0].id}
          validate={selectRequired}
          id="delivery"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <FormDataConsumer>
          {({ formData }) => {
            let parameterChoices = [];
            if (formData.deliveryMethod === 'MAIL') {
              parameterChoices = userAddressesTypesAvailable;
            }

            return (
              formData.deliveryMethod &&
              formData.deliveryMethod !== 'EMAIL' && (
                <SelectInput
                  variant="standard"
                  className={classes.inputRoot}
                  disabled={!formData}
                  source="parameter"
                  validate={selectRequired}
                  choices={parameterChoices}
                  optioenxt="name"
                  id="parameter"
                />
              )
            );
          }}
        </FormDataConsumer>
      </Grid>
    </Grid>
  );
};

const UserNotificationForm = ({
  handleSubmit,
  notificationFormRef,
  setNotificationFormValues,
  notificationFormValues,
  operation,
  showDialog,
  handleDialogToggle,
  crudGetManyReference,
  fetchEnd,
  fetchStart,
  crudGetList,
  loaded,
  currentSort,
  setSort,
  popupTitle,
  okButtonLabel,
  investors,
  fundsChoices,
  documentTypes,
  fundInvestors,
  allInvestors,
  userphonetypes,
  userAddressesTypesAvailable,
  loading,
  ...operationProps
}) => {
  const classes = useStyles();
  return (
    <Create {...operationProps} className={classes.fullWidth}>
      <SimpleFormWithSave
        toolbar={null}
        // We override the redux-form name to avoid collision with the react-admin main form
        resource="usernotifications"
        // We override the redux-form onSubmit prop to handle the submission ourselves
        onSave={handleSubmit}
        variant="standard"
        margin="normal"
      >
        <>
          <UserNotificationFormFields
            operation={operation}
            fundsChoices={fundsChoices}
            fundInvestors={fundInvestors}
            allInvestors={allInvestors}
            documentTypes={documentTypes}
            userAddressesTypesAvailable={userAddressesTypesAvailable}
            userphonetypes={userphonetypes}
            loading={loading}
          />
          {loading && <CircularProgress />}
          <FormSpy>
            {({ form, values }) => {
              notificationFormRef.current = form;
              if (!isEqual(notificationFormValues, values)) {
                setTimeout(() => setNotificationFormValues(values));
              }
              return null;
            }}
          </FormSpy>
        </>
      </SimpleFormWithSave>
    </Create>
  );
};

export default UserNotificationForm;
